import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { academicYearsApi, apiClient } from '@/api'

export interface AcademicYear {
  id: string
  label: string
  startsAt: string
  endsAt: string
  isActive: boolean
}

export const useAcademicYearStore = defineStore('academicYear', () => {
  const years = ref<AcademicYear[]>([])
  const activeYearId = ref<string | null>(null)
  const isLoaded = ref(false)

  const activeYear = computed(() => years.value.find(y => y.isActive) ?? null)

  async function fetchYears() {
    try {
      const res = await academicYearsApi.academicYearsGet()
      const data = res.data as any
      years.value = (data.years ?? []).map((y: any) => ({
        id: y.id,
        label: y.label ?? '',
        startsAt: y.startsAt ?? '',
        endsAt: y.endsAt ?? '',
        isActive: y.isActive ?? false,
      }))
      activeYearId.value = data.activeAcademicYearId ?? null
      isLoaded.value = true
    } catch {
      // Silently fail
    }
  }

  async function activateYear(yearId: string) {
    try {
      await apiClient.post(`/academic-years/${yearId}/activate`)
      // Update local state optimistically
      years.value = years.value.map(y => ({ ...y, isActive: y.id === yearId }))
      activeYearId.value = yearId
    } catch {
      // Revert by refetching
      await fetchYears()
      throw new Error('Failed to activate year')
    }
  }

  return {
    years,
    activeYear,
    activeYearId,
    isLoaded,
    fetchYears,
    activateYear,
  }
})
